<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">参数设置</div>
      <el-form-item label="是否开启聚水潭发货" prop="is_open">
        <el-switch v-model="form.is_open">
        </el-switch>
      </el-form-item>
      <el-form-item label="AppKey">
        <el-input v-model="form.app_key" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret">
        <el-input v-model="form.app_secret" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="accessToken">
        <el-input v-model="form.access_token" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="refreshToken">
        <el-input v-model="form.refresh_token" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="店铺id">
        <el-input v-model="form.shop_id" class="max-w460"></el-input>
      </el-form-item>
      

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          is_open: '',
          app_key: '',
          app_secret: '',
          access_token: '',
          refresh_token: '',
          shop_id: '',
        },
        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        SettingApi.jushuitanSetting({}, true)
          .then(data => {
            self.form = data.data.setting;
          })
          .catch(error => {});

      },
      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.saveJushuitanSetting(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },



    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/jushuitan/index.vue